<template>
	<div class="testbg">
		
		
		
		<el-row class="mt-3" :gutter="20">
			<el-col v-for="(v,i) in head_list" :key="i" :span="6" :xs="24" class="mb-3">
				<el-card class="box-card"  shadow="hover">
					<router-link  style="text-decoration: none;" :to="{name:v.url}">
						<div class="new_head_nav" >
							<div class="new_head_nav_icon" :style="{'background-color':v.bg,'box-shadow':'0 3px 18px -8px '+v.bg}">
								<i  :class="v.icon"></i>
							</div>
							<div class="ml-3 new_head_right">
								<div class="new_info">{{v.title}}</div>
								<div class="new_head_num">{{v.total}}</div>
								
								<div class="new_info_div">
									<div class="new_info">{{v.info}}</div>
									<div v-if="v.info2" class="new_info">{{v.info2}}</div>
								</div>
								
							</div>
						</div>
					</router-link>
				</el-card>
			</el-col>
		</el-row>
	
		<div class="home_all" :class="this.layout.is_phone?'home_all_phone':''">
			<el-row :gutter="layout.index_p.gutter" class=" h_l" >
					<!-- 左边 -->
					<el-col  :span="24" class="pb-4 h_100" >
						<el-card class="box-card h_100 new_card "  shadow="hover">
								<div slot="header" class="clearfix">
									<span>比賽記錄</span>
								</div>
								   <el-table
								   height="330"
								      :data="tableDataCom" 
								      style="width: 100%;">
									  
										<el-table-column align="center" width="110" prop="com_no" label="比賽編號">
										</el-table-column>
											
										<el-table-column align="center" prop="title" label="比賽名稱">
													<template slot-scope="scope">
														<div v-if="scope.row.title.length > 20">
															{{ scope.row.title.substring(0, 20) }}... 
															<el-button type="text" @click="showFullTitle(scope.row.title)">點擊查看</el-button>
														</div>
														<div v-else>
															{{ scope.row.title }}
														</div>
													</template>
										</el-table-column>

										<el-table-column align="center" width="100" prop="content" label="比賽簡介">
											<template slot-scope="scope">
												<div slot="reference" style="cursor: pointer;"  class="name-wrapper"  @click="openDialog(scope.row.content)">
														<el-tag size="medium">查看</el-tag>
													</div>
											</template>
										</el-table-column>

										<el-table-column align="center" width="100" prop="subject_name" label="學科">
										</el-table-column>
										
										<el-table-column align="center" prop="ins_name" label="機構名稱">
										</el-table-column>

										<el-table-column align="center" width="80" prop="join_count_zero" label="報名人數">
										</el-table-column>

										<el-table-column align="center" width="80" prop="join_count" label="完成人數">
										</el-table-column>
										
										<el-table-column align="center" width="80"  prop="pay_type" label="費用">
											<template slot-scope="v">
													<span  class="text-warning" v-if="v.row.pay_type==1">免費</span>
													<span v-if="v.row.pay_type==2">{{v.row.money}}</span>
												</template>
										</el-table-column>

										<el-table-column align="center" width="100" prop="apply_status" label="報名進度">
												<template slot-scope="v">
													<span  class="text-warning" v-if="v.row.apply_status==0">未開始</span>
													<span class="text-success" v-if="v.row.apply_status==1">進行中</span>
													<span class="text-danger" v-if="v.row.apply_status==2">已結束</span>
												</template>
										</el-table-column>

										<el-table-column align="center" width="100" prop="start_status" label="比賽進度">
												<template slot-scope="v">
													<span  class="text-warning" v-if="v.row.start_status==0">未開始</span>
													<span class="text-success" v-if="v.row.start_status==1">進行中</span>
													<span class="text-primary" v-if="v.row.start_status==2">已結束</span>
													<span class="text-info" v-if="v.row.start_status==3">待公佈</span>
													<span class="text-danger" v-if="v.row.start_status==4">已公佈</span>
												</template>
										</el-table-column>

										<el-table-column align="center" width="100" prop="audit_status" label="公佈狀態">
												<template slot-scope="v">
													<span  class="text-warning" v-if="v.row.audit_status==0">未提交</span>
													<span class="text-success" v-if="v.row.audit_status==1">待審核</span>
													<span class="text-danger" v-if="v.row.audit_status==2">已完成</span>
													<span class="text-danger" v-if="v.row.audit_status==3">已駁回</span>
												</template>
										</el-table-column>
								    </el-table>
									
									<div class="mt-2" style="overflow-x: auto;">
										<el-pagination
										:current-page="page_com.current" :page-sizes="page_com.sizes" :page-size="page_com.size" @size-change="handleSizeChangeCom"
										 @current-change="handleCurrentChangeCom" layout="total, sizes, prev, pager, next, jumper" :total="page_com.total">
										</el-pagination>
									</div>
							</el-card>
					</el-col>
			</el-row>

				
			<el-row :gutter="layout.index_p.gutter" class=" h_l" >
					<!-- 左边 -->
					<el-col  :span="24" class="pb-4 h_100" >
						<el-card class="box-card h_100 new_card "  shadow="hover">
								<div slot="header" class="clearfix">
									<span>公告列表</span>
								</div>
								   <el-table
								   height="330"
								      :data="tableDataNot" 
								      style="width: 100%;">
															
									<el-table-column align="center" width="140" prop="notice_no" label="公告編號">
									</el-table-column>
								
									<el-table-column align="center" prop="title" label="發送標題">
									<template slot-scope="scope">
									<div v-if="scope.row.title.length > 20">
										{{ scope.row.title.substring(0, 20) }}... 
										<el-button type="text" @click="showFullTitle(scope.row.title)">點擊查看</el-button>
									</div>
									<div v-else>
										{{ scope.row.title }}
									</div>
										</template>
										</el-table-column>

									<el-table-column align="center" width="100" prop="content" label="公告內容">
											<template slot-scope="scope">
												<div slot="reference" style="cursor: pointer;"  class="name-wrapper"  @click="openDialogs(scope.row)">
														<el-tag size="medium">查看</el-tag>
													</div>
											</template>
										</el-table-column>
									
									<el-table-column align="center" width="120" prop="type"  label="類型">
										<template slot-scope="v">
											<span class="text-success" v-if="v.row.type==2">後台發送</span>
											<span class="text-warning" v-if="v.row.type==3">機構發送</span>
										</template>
									</el-table-column>
									
									<el-table-column align="center" width="120" prop="check_status"  label="是否已讀">
										<template slot-scope="v">
											<span style="color: red;" v-if="v.row.check_status==0">未讀</span>
											<span class="text-success" v-if="v.row.check_status==1">已讀</span>
										</template>
									</el-table-column>

									<el-table-column align="center"  prop="create_time" width="200" label="發送時間">
									</el-table-column>
								
								    </el-table>
									<div class="mt-2" style="overflow-x: auto;">
										<el-pagination
										:current-page="page_not.current" :page-sizes="page_not.sizes" :page-size="page_not.size" @size-change="handleSizeChangeNot"
										 @current-change="handleCurrentChangeNot" layout="total, sizes, prev, pager, next, jumper" :total="page_not.total">
										</el-pagination>
									</div>
									
							</el-card>
					</el-col>
					
					
			</el-row>

			<!-- 登錄明细 收支统计 -->
			<el-row :gutter="layout.index_p.gutter" class=" h_l" >
					<!-- 左边 -->
			
					<el-col  :span="24" class="pb-4 h_100" >
						<el-card class="box-card h_100 new_card "  shadow="hover">
							<div slot="header" class="clearfix">
								<span>近30天數據統計</span>
							</div>
							
							<!-- 统计图容器 -->
							<div ref="myChart" style="width: 100%;height: 270px;">
							
							</div>
							
						</el-card>
					</el-col>
					
			</el-row>
		

			<!-- <el-row :gutter="layout.index_p.gutter" class=" h_l" >
				
					<el-col  :span="24" class="pb-4 h_200" >
						<el-card class="box-card h_200 new_card "  shadow="hover">
								<div slot="header" class="clearfix">
									<span>登錄日誌</span>
								</div>
								   <el-table
								   height="530"
								      :data="tableDataNot" 
								      style="width: 100%;">
									  <el-table-column align="center" type="index" label="排序" width="50">
									  </el-table-column>
								      <el-table-column align="center"
								        prop="create_time"
								        label="登錄時間"
								        >
								      </el-table-column>
								      <el-table-column
								        prop="browse" align="center" 
								        label="瀏覽器"
								        >
								      </el-table-column>
									  
									  <el-table-column
									    prop="ip" width="150" align="center"
									    label="IP地址">
										</el-table-column>
									  <el-table-column
									    prop="sysversion"  align="center"
									    label="操作系統">
									  </el-table-column>
								
								    </el-table>
									
									<div class="mt-2" style="overflow-x: auto;">
										<el-pagination
										:current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
										 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
										</el-pagination>
									</div>
									
							</el-card>
					</el-col>
					
					
			</el-row> -->

			
			
			
			
			<!-- 登錄明细 收支统计 -->
			<!-- <el-row :gutter="layout.index_p.gutter" class=" h_l" >
			
					<el-col  :span="24" class="pb-4 h_100" >
						<el-card class="box-card h_100 new_card "  shadow="hover">
							<div slot="header" class="clearfix">
								<span>近30天</span>
							</div>
							
							
							<div ref="myChart5" style="width: 100%;height: 270px;">
							
							</div>
							
						</el-card>
					</el-col>
					
					
				
					
			</el-row> -->
			
			
<!-- 			
			<el-row :gutter="layout.index_p.gutter" class="mt-3 h_l" >
					
			
					<el-col  :span="layout.index_p.span2" class="pb-4 h_100" >
						<el-card class="box-card h_100 new_card "  shadow="hover">
							<div slot="header" class="clearfix">
								<span>比賽占比</span>
							</div>
							
							
							<div ref="myChart3" style="width: 100%;height: 270px;">
							
							</div>
							
						</el-card>
					</el-col>
					
					
			
								
					<el-col  :span="layout.index_p.span2" class="pb-4 h_100" >
						<el-card class="box-card h_100 new_card "  shadow="hover">
							<div slot="header" class="clearfix">
								<span>练习占比</span>
							</div>
							
							
							<div ref="myChart4" style="width: 100%;height: 270px;">
							
							</div>
							
						</el-card>
					</el-col>
					
					
				
					
			</el-row> -->
			
			
			<!-- <el-row :gutter="layout.index_p.gutter" class=" h_1" > -->
					<!-- 左边 -->
			
					<!-- <el-col  :span="layout.index_p.span2" class=" h_100" >
						<el-card class="box-card h_100"  shadow="hover">
							<div slot="header" class="clearfix">
								<span>做題分布</span>
							</div>
					
							<div ref="myChart2" style="width: 100%;height: 270px;">
							
							</div>
						</el-card>
					</el-col>
					 -->
					<!-- 右边 -->
					<!-- <el-col :span="layout.index_p.span2" class="pb-4 h_100" :class="this.layout.is_phone?'pb-4':''">
							<el-card class="box-card h_100 " shadow="hover" >
								<div slot="header" class="clearfix">
									<span>登錄日誌</span>
								
								</div>
								
								   <el-table
								   height="230"
								      :data="tableData" 
								      style="width: 100%;">
									  <el-table-column align="center" type="index" label="排序" width="50">
									  </el-table-column>
								      <el-table-column align="center" width="180"
								        prop="create_time"
								        label="登錄時間"
								        >
								      </el-table-column>
								      <el-table-column
								        prop="browse" align="center" width="140"
								        label="瀏覽器"
								        >
								      </el-table-column>
									  
									  <el-table-column
									    prop="ip" width="150" align="center"
									    label="UP地址">
										</el-table-column>
									  <el-table-column
									    prop="sysversion" width="200" align="center"
									    label="操作系統">
									  </el-table-column>
								
								    </el-table>
									
									<div class="mt-2" style="overflow-x: auto;">
										<el-pagination
										:current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
										 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
										</el-pagination>
									</div>
									
							</el-card>
							
						</el-col>
					 -->
					
					
			<!-- </el-row> -->
			
					
			<div v-if="this.layout.is_phone">.</div>
			<div style="width: 100%;height: 80px;"></div>
		</div>
	
		
		
		
		
	
		

		<el-dialog :close-on-click-modal="false"  :visible.sync="dialogTitleVisible" title="題目">
			<p>{{ fullTitle }}</p>
		</el-dialog>
	
		
		
	<el-dialog :close-on-click-modal="false"  :visible.sync="dialogVisible" :width="layout.is_phone?'90%':'70%'" :title="dialogTitle" @close="closeDialog">
						<!-- 使用 v-html 渲染 HTML 内容 -->
						<div v-html="dialogContent" class="dialog-content"></div>
						
						<span slot="footer" class="dialog-footer" >
							<el-button @click="closeDialog">關閉</el-button>
						</span>
					</el-dialog>

	
	<!-- 修改提现地址 -->
	
	<el-dialog  :close-on-click-modal="false" :title="edit_title" :visible.sync="createModel" top="5vh">
		<!-- 表單内容 -->
		<el-form :rules="rules" ref="form" :model="form" label-width="100px">
	
			<el-form-item label="提现地址" prop="url">
				<el-input v-model="form.url" placeholder="提现地址" clearable size="small" style="width: 50%;"></el-input>
			</el-form-item>
			
	
		</el-form>
	
		<div slot="footer" class="dialog-footer">
			<el-button @click="createModel = false">取 消</el-button>
			<el-button type="primary" @click="submit">確 定</el-button>
		</div>
	</el-dialog>
	

	</div>
</template>

<script>
	//图形统计导入
	import common from '@/common/mixins/common.js';
	import echarts from 'echarts'
	import { mapState } from 'vuex';
	export default {
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				preUrl: "user/homeData", //列表地址
				tableData: [],
				shoplist: {},
				orderlist: {},
				counts: [],
				head_list:[],
				mtCheck:0,
				mtMoney:'',

				dialogTitleVisible: false,
				fullTitle: '',
				dialogTitle: '',


				page_com: {
					current: 1,
					sizes: [10, 20, 50, 100],
					size: 10,
					total: 0
				},

				page_not: {
					current: 1,
					sizes: [10, 20, 50, 100],
					size: 10,
					total: 0
				},
			
				tableData:[],
				tableDataCom:[],
				tableDataNot:[],
				createModel:false,
				edit_title:'',
				// addUrl: "user/editTxUrl", //修改提现地址
				addUrl: "data/setNoticeRead", //添加/修改地址
				form:{
					url:'',
					type:0
				},
				search:{
					date:''
				},
				
				rules: {
					url: [{
							required: true,
							message: "請輸入提现地址",
							trigger: 'blur',
						},
					
					]
				},

				dialogVisible: false,      // 控制對話框顯示
				dialogContent: '' ,         // 存储當前对话框的内容
				
				order_list:[],
				sq_info:{
					'tk':{
						'status':0,
						'time':'',
						'url':''
					},
					'se':{
						'status':0,
						'time':'',
						'url':''
					},
					'la':{
						'status':0,
						'time':'',
						'url':''
					}
				}
			
			}
		},
		filters: {
			getCol(total) {
				return `col-${12/total}`
			}
		},
		watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		//dom渲染完毕 
		mounted() {
			//画统计图
			//this.drawLine()
		},
		methods: {
			 // 顯示完整標題内容
			 showFullTitle(title) {
				this.fullTitle = title;
				this.dialogTitleVisible = true;
			},
			openDialogs(row) {
				this.dialogContent = row.content; // 设置要顯示的 HTML 内容
				this.dialogTitle = row.title; // 设置要顯示的 HTML 内容
				this.dialogVisible = true;    // 顯示对话框
				if(row.check_status == 0){
					this.form.type = 3;
					this.form.id = row.id;
					this.addOrEdit(this.form,true,false,false)
				}
			},
			
			openDialog(content) {
				this.dialogContent = content; // 设置要顯示的 HTML 内容
				this.dialogVisible = true;    // 顯示对话框
			},
			closeDialog() {
				this.dialogVisible = false;   // 關閉对话框
				this.dialogContent = '';      // 清空内容
			},
			handleCurrentChangeCom(val) {
				this.search.com_page = val
				this.getList()
			},
			handleSizeChangeCom(val) {
				this.search.com_size = val
				this.getList()
			},

			handleCurrentChangeNot(val) {
				this.search.not_page = val
				this.getList()
			},
			handleSizeChangeNot(val) {
				this.search.not_size = val
				this.getList()
			},
			updateHomeTime(){
				this.page.current = 1
				this.getList()
			},
			submit(type) {
				this.$refs.form.validate(res => {
					if (res) {
						this.addOrEdit(this.form)
					}
				})
				
				
			},
			getListResult(e) {
				this.page.total = e.total
				this.tableData = e.log_list

				this.page_com.total = e.com_total
				this.tableDataCom = e.com_list


				this.page_not.total = e.not_total
				this.tableDataNot = e.not_list

				if(this.page.current==1){
					this.order_list = e.order_list
					this.sq_info = e.sq_info
					this.head_list = e.head_list
				}
				
				this.drawLine()
				this.drawLine2()
				this.drawLine3()
				this.drawLine4()
				this.drawLine5()

			},
			
			drawLine3() {
				//初始化echarts实例 
				//console.log(this.$refs.myChart);
				let myChart = echarts.init(this.$refs.myChart3);
				// 配置參數
			
				myChart.setOption(
					{
					 
					  tooltip: {
					    trigger: 'item'
					  },
					  legend: {
					    orient: 'vertical',
					    left: 'left'
					  },
					  series: [
					    {
					      name: '數量',
					      type: 'pie',
					      radius: '50%',
					      data: this.order_list.fb1,
					      emphasis: {
					        itemStyle: {
					          shadowBlur: 10,
					          shadowOffsetX: 0,
					          shadowColor: 'rgba(0, 0, 0, 0.5)'
					        }
					      }
					    }
					  ]
					}
				)
			},
			
					
			drawLine4() {
				//初始化echarts实例 
				//console.log(this.$refs.myChart);
				let myChart = echarts.init(this.$refs.myChart4);
				// 配置參數
			
				myChart.setOption(
					{
					 
					  tooltip: {
					    trigger: 'item'
					  },
					  legend: {
					    orient: 'vertical',
					    left: 'left'
					  },
					  series: [
					    {
					      name: '數量',
					      type: 'pie',
					      radius: '50%',
					      data: this.order_list.fb2,
					      emphasis: {
					        itemStyle: {
					          shadowBlur: 10,
					          shadowOffsetX: 0,
					          shadowColor: 'rgba(0, 0, 0, 0.5)'
					        }
					      }
					    }
					  ]
					}
				)
			},
			
			
			
			
			drawLine() {
				//初始化echarts实例 
				//console.log(this.$refs.myChart);
				let myChart = echarts.init(this.$refs.myChart);
				// 配置參數

				myChart.setOption(
					{
					
					  tooltip: {
					    trigger: 'axis'
					  },
					  legend: {
					    data: ['新增用戶', '自行註冊', '學校註冊']
					  },
					  grid: {
					    left: '3%',
					    right: '4%',
					    bottom: '3%',
					    containLabel: true
					  },
					  toolbox: {
					    feature: {
							magicType: { show: true, type: ['line', 'bar'] },
							restore: { show: true },
					      saveAsImage: {}
					    }
					  },
					  xAxis: {
					    type: 'category',
					    boundaryGap: false,
					    data: this.order_list.day.date
					  },
					  yAxis: {
					    type: 'value'
					  },
					  series: [
						  {
						    name: '新增用戶',
						    type: 'line',
						    stack: '',
						    color:'#ffda4a',
						    data: this.order_list.day.first
						  },
					    
					    {
					      name: '自行註冊',
					      type: 'line',
					      stack: '',
						  color:'#6ad3a7',
					      data: this.order_list.day.order_1
					    },
						{
						  name: '學校註冊',
						  type: 'line',
						  stack: '',
						   color:'#ff888a',
						  data: this.order_list.day.order_2
						}]
					}
				)
			},
			
			drawLine5() {
				//初始化echarts实例 
				//console.log(this.$refs.myChart);
				let myChart = echarts.init(this.$refs.myChart5);
				// 配置參數
			
				myChart.setOption(
					{
					
					  tooltip: {
					    trigger: 'axis'
					  },
					  legend: {
					    data: ['總費用','入库空运','入库海运','上架費','退货上架','退仓','弃货','订單出库','仓储費']
					  },
					  grid: {
					    left: '3%',
					    right: '4%',
					    bottom: '3%',
					    containLabel: true
					  },
					  toolbox: {
					    feature: {
							magicType: { show: true, type: ['line', 'bar'] },
							restore: { show: true },
					      saveAsImage: {}
					    }
					  },
					  xAxis: {
					    type: 'category',
					    boundaryGap: false,
					    data: this.order_list.day.date
					  },
					  yAxis: {
					    type: 'value'
					  },
					  series: [
						  {
						    name: '總費用',
						    type: 'line',
						    stack: '',
						    color:'#009ec7',
						    data: this.order_list.day.total
						  },
						  {
						    name: '入库空运',
						    type: 'line',
						    stack: '',
						    data: this.order_list.day.t_1
						  },
						  {
						    name: '入库海运',
						    type: 'line',
						    stack: '',
						    data: this.order_list.day.t_2
						  },
						  {
						    name: '上架費',
						    type: 'line',
						    stack: '',
						    data: this.order_list.day.t_3
						  },
						  {
						    name: '退货上架',
						    type: 'line',
						    stack: '',
						    data: this.order_list.day.t_4
						  },
						  {
						    name: '退仓',
						    type: 'line',
						    stack: '',
						    data: this.order_list.day.t_5
						  },
						  {
						    name: '弃货',
						    type: 'line',
						    stack: '',
						    data: this.order_list.day.t_6
						  },
						  {
						    name: '订單出库',
						    type: 'line',
						    stack: '',
						    data: this.order_list.day.t_7
						  },
						  {
						    name: '仓储費',
						    type: 'line',
						    stack: '',
						    data: this.order_list.day.t_8
						  },
					  ]
					}
				)
			},
			
			drawLine2() {
				//初始化echarts实例 
				//console.log(this.$refs.myChart);
				let myChart = echarts.init(this.$refs.myChart2);
				// 配置參數
			
				myChart.setOption(
					{
					  tooltip: {
					    trigger: 'item'
					  },
					  legend: {
					    orient: 'vertical',
					    left: 'left'
					  },
					  series: [
					    {
					      name: '數量',
					      type: 'pie',
					      radius: '50%',
					      data: this.order_list.fb,
					      emphasis: {
					        itemStyle: {
					          shadowBlur: 10,
					          shadowOffsetX: 0,
					          shadowColor: 'rgba(0, 0, 0, 0.5)'
					        }
					      }
					    }
					  ]
					}
				)
			},
			
			startLine(){
				console.log(startLine)
			},
			
			//前往修改页面
			toView(name) {
				for (var i = 0; i < this.layout.navBar.list.length; i++) {
					
					let index = this.layout.navBar.list[i].submenu.findIndex(v => v.pathname == name);
					if(index!=-1){
						this.layout.navBar.active = i;
						// 跳转到當前激活
						this.layout.slideMenuActive = index
						break
					}
				}
				this.$router.push({
					name: name,

				})
			},
			// 打开模态框
			openModel(e, type) {
				// console.log(e)
				this.edit_title = '修改'+e.desc
				// 修改
				this.form = {
					url: e.num,
					type:e.o_type
				}
			
				// 打开dialog
				this.createModel = true
			}
		}
	}
</script>

<style>
	.index_btn{
		display: flex; align-items: center;justify-content: space-between;
	}
	.index_btn_left{
		background-color: #83d8ae;
		box-shadow: 0 3px 18px -8px #83d8ae;
		width: 45px;
		height: 45px;
		
		border-radius: 5px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.index_btn_left2{
		background-color: #fc9494;
		box-shadow: 0 3px 18px -8px #fc9494;
	}
	.index_btn_left3{
		background-color: #3b8ff3;
		box-shadow: 0 3px 18px -8px #3b8ff3;
	}
	.index_btn_name{
		font-size: 20px;
	}
	.index_btn_info{
		font-size: 13px;color: #aaa;
	}
	
	.index_btn_ft28{
		font-size: 28px;
	}
	
	
	
	.new_home_p{
		font-size: 15px;
		font-weight: bolder;
		color: #333;
		margin-left: 10px;
	}
	.head_row .el-card__body{
		padding: 15px 10px;
	}
	

	.htr_main{
		display: flex;align-items:center;flex-direction: column;justify-content: center;
	}
	.htr_view{
		display: flex;align-items: center;
		justify-content: space-between;
		
		
		
		
		width: 100%;
	}
	.htr_top{
		border-radius: 5px;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		
	}
	.htr_top_new{
	}
	
	.htr_info{
		font-size: 14px;color: #92c0e9;
		
	}
	.htr_desc{
		color: #fff;font-size: 13px;
		text-align: right;
	}
	.htr_icon{
		width: 45px;height: 45px;color: #fff;
		background-color: #83d8ae;
		box-shadow: 0 3px 18px -8px #83d8ae;
		border-radius: 5px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.htr_icon i{
		font-size: 25px;
	}
	.htr_icon_red{
		background: #fc9494;
		box-shadow: 0 3px 18px -8px #fc9494;
	}
	
	
	
	.testbg{
		height: 100%;
	}
	.home_all{
		color: #fff;
		height: calc(100% - 130px);
		
	}
	
	.testbg .el-card__header{
		padding: 10px 20px;
		font-size: 15px;
	}
	.new_card .el-card__body{
		height: calc(100% - 44px);
	}
	.zj_card .el-card__body{
		height: 100%;
	}
	.h_100{
		height: 100%;
	}
	.h_50{
		height: 50%;
	}
	.h_l{
		height: auto;
	}
	.h_r{
		height: auto;
	}
	
	
	.home_all_phone .h_l,.home_all_phone .h_r{
		height: auto;
	}
	/* 新选项數据 */
	.new_head_nav{
		display: flex;align-items: center;
	}
	
	.new_head_nav_icon{
		width: 45px;
		height: 45px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 50%;
		color: #fff;
		
	}
	
	.new_head_nav_icon i{
		font-size: 25px;
	}
	
	.new_info_div{
		display: flex;
		width: 100%;
		justify-content: space-between;
	}
	.new_head_right{
		flex: 1;
	}
	.new_info{
		color: grey;
		font-size: 13px;
	}
	
	.new_head_num{
		color: #222;
		font-size: 25px;
		margin: px 0;
	}
	
	
	/* 新选项數据 */
	
</style>
